<script lang="ts">
  import { round } from "@/Util/utils";
    import type {HoursAchievability} from "../../modules/ProgramAchievability"
    type $$Props = HoursAchievability & {
        hours_target: number
    }
    export let status: $$Props["status"]
    export let hours_achievable: $$Props["hours_achievable"]
    export let hours_target: $$Props["hours_target"]
</script>
<div class="text-sm text-slate-500">
    {#if status === "fine"}
    Your maximum weekly hours estimated is <span class="font-medium">{round(hours_achievable, 1)}h</span>.
    {:else if status === "warning"}
    The weekly hours needed for training exceeds your maximum. 
    {:else}
    The weekly hours required to complete this race are not feasible.
    {/if}
</div>